import { inject, Injectable, Signal, WritableSignal } from '@angular/core';
import { MPKSignalStore } from './mpk.store';
import { MPKeys } from '@lentau/mpk/shared/constants';
import { Observable } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { MARKETING_PARTNER_KEY_INJECTION_TOKEN } from '@lentau/mpk/shared/marketing-partner-key.token';

@Injectable({
  providedIn: 'root',
})
export class MpkFacade {
  private mpkSignalStore = inject(MPKSignalStore);
  private mpkToken: WritableSignal<string> = inject(MARKETING_PARTNER_KEY_INJECTION_TOKEN);

  public mpk: Signal<MPKeys> = this.mpkSignalStore.mpk;
  public mpk$: Observable<MPKeys> = toObservable(this.mpk);
  public isInit: Signal<boolean> = this.mpkSignalStore.isInit;
  public isInit$: Observable<boolean> = toObservable(this.isInit);

  public initMPK(mpk: MPKeys): void {
    this.mpkSignalStore.initMPK(mpk);
    this.mpkToken.set(mpk);
  }

  public setMPK(mpk: MPKeys): void {
    this.mpkSignalStore.setMPK(mpk);
    this.mpkToken.set(mpk);
  }
}
